<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form">
					<c-form-item type="datetime" label="变化时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="input" label="会员信息" name="user_info" placeholder="匹配昵称、手机号"></c-form-item>
					<c-form-item type="select" label="渠道" name="type" :options="typeDic"></c-form-item>
					<c-form-item type="select" label="收支类型" name="income_expenses" :options="state"></c-form-item>
				</c-form>
			</m-search>

      <m-operate>
        <c-button hollow power="b_growth_record_export" @click="syncExport()" >导出成长值明细</c-button>
        <!--				<c-button power="b_growth_import" @click="importGrowth()" hollow icon="upload">导入成长值</c-button>-->

        <template #right>
          <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">
            编辑导出列
          </c-button>
        </template>
      </m-operate>
			
			<c-table ref="table">
        <c-table-column type="selector" ></c-table-column>

        <c-table-column
					label="变化时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					label="收支类型"
					name="income_expenses"
					width="80"
				>
				  <template v-slot="{data}">
					<span v-if="data.income_expenses == 1" style="color:green">收入</span>
					<span v-if="data.income_expenses == 2" style="color:red">支出</span>
				  </template>
				</c-table-column>
		
				<c-table-column
					label="渠道"
					name="type"
					width="100"
				>
				  <template v-slot="{data}">
					{{typeMap[data.type]}}
				  </template>
				</c-table-column>
		
				<c-table-column
					label="变更成长值"
					name="value"
					width="90"
				>
					<template v-slot="{data}">
                      <span v-if="data.income_expenses == 1" style="color:green"> + {{data.value}}</span>
                      <span v-if="data.income_expenses == 2" style="color:red"> - {{data.value}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="关联订单号"
					name="order_number"
					width="130"
				>
					<template v-slot="{data}">
					  <span v-if="data.type == 5 || data.type==6" style="color:green">{{data.order_number}}</span>
					  <span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="最新成长值"
					name="value_balance"
					width="90"
				>
				</c-table-column>

                <c-table-column
                        label="代理头像/昵称"
                        name="head_photo"
                        width="220"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <div>
                            <span>昵称：{{data.nick_name}}</span></br>
                            <span>手机号：{{data.user_manage_mobilephone}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                  label="详细说明"
                  name="remark"
                  width="700"
                ></c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

  export default {
		name: 'm_growth_record',
		
		data() {
			return {
        workType:32,
        searchParams:{},
				state: [{
					name: '收入',
					value: 1
				}, {
					name: '支出',
					value: 2
				}],
				typeDic: [{
					name: '注册',
					value: 1
				}, {
					name: '完善资料',
					value: 2
				}, {
					name: '签到',
					value: 3
				}, {
					name: '分享',
					value: 4
				}, {
					name: '订单消费',
					value: 5
				}, {
					name: '订单评价',
					value: 6
				}, {
                    name: '社区发帖(分享)',
                    value: 7
                }, {
                    name: '社区发帖(话题)',
                    value: 8
                }, {
                    name: '社区评论',
                    value: 9
                }, {
					name: '其他',
					value: 99
				}],
				typeMap:{}
			}
		},

    computed: {
      ...mapState(['systemConfig', 'userInfo']),
    },

		mounted() {
			this.$refs.search.search();
			
			// 使用reduce方法将数组转换为以value为键，name为值的对象
			this.typeMap = this.typeDic.reduce((map, item) => {
				map[item.value] = item.name;
				return map;
			}, {});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/growth_record/list',
					data
				});
        this.searchParams = data||{};
			},
      /**同步导出数据*/
      syncExport(){
        var selectDatas = this.$refs.table.getRow('selected');
        var ids = [];
        if (selectDatas.length && selectDatas.length>0) {
          ids = Array.from(selectDatas, item => item.data.id);
        }
        this.export(this.workType,this.searchParams,ids);
      },

			importGrowth(){
				this.$confirm({
				    title: '导入成长值提示',
				    buttonName: '选择文件',  // 确定按钮文字
				    text: '请使用标准模板进行导入 <a href="https://wxh2025.oss-cn-hangzhou.aliyuncs.com/app_static/%E6%88%90%E9%95%BF%E5%80%BC%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx" target="_blank" style="color:dodgerblue;">导入模板下载</a>',
				    resolve: () => {
				        this.uploadFile({
				            message: false,
				            success: data => {
				                this.request({
				                    url: '/growth_record/import',
				                    data: {
				                        filePath: data.filePath
				                    },
				                    loading: true,
				                    timeout: false,
				                    success: (data, message) => {
				                        this.$refs.table.update();
				                        this.$confirm({
				                            title: '执行结果',
				                            text: message,  // 提示内容,
				                            buttonName: '确定',  // 确定按钮文字
				                            icon: 'success',
				                            cancelButton: false  // 是否显示取消按钮
				                        });
				                    }
				                });
				            }
				        })
				    }
				});
			},
            exportData(){
                var exportData = this.$refs.form.serialize();
                exportData.job_id = 39;
                exportData.create_system = 'OMS';

                this.request({
                    url: '/export_job/add',
                    data: exportData,
                    success: data => {
                        this.$message({
                            text: '导出任务创建成功，请前往任务中心查看导出进度',
                            icon: 'success'
                        });
                    }
                });
            }
		}
	}
</script>